import { ICompositionGroup } from "../types/Product";
import { IPlaceData } from "../types/Place";
import { IPaymentType } from "../types/Payment";
import { IShoppingBagData, IShoppingBagItem } from "../types/ShoppingBag";
import { ILoginData } from "../types/Login";

const template = "Olá, sou {nomeDoCliente} e acabei de fazer o pedido nº {numeroDoPedido}.\n" +
  "O pedido é {deliveryOuPickup} e o valor total é {valorTotal} em {formaPagamento} {comOuSemTrocoEQuanto}.\n" +
  "Os itens:\n" +
  "{itensDoPedido}\n" +
  "\n" +
  "Obrigado!";

const subitens = (groups: ICompositionGroup[] | undefined) => {
  if (!groups) return "";
  if (groups.length < 1) return "";

  return groups.map(group => {
    if (!group.compositionGroupItems) return "";
    if (group.compositionGroupItems.length < 1) return "";

    const itensComQuantidade = group.compositionGroupItems.filter(i => i.quantity > 0);

    if(itensComQuantidade.length < 1) return "";

    const nomeGrupo = group.compositionGroupInfo?.description ?? "Composição:";
    const itens = itensComQuantidade.map(item => {
      if(item.quantity < 1) return "";
      return `\n      - ${item.quantity}x ${item.name}` +
        (item.observations ? `\n      - Observação: ${item.observations.replace("\n", " ")}` : "");
    }).join("");

    return `\n   - _${nomeGrupo}:_${itens}`;
  }).filter(i=> i != '').join("\n");
};

const mapItem = (item: IShoppingBagItem | undefined) => {
  if (!item) return "";
  return `  - ${item.quantity}x *${item.productInfo?.name}*` + subitens(item.compositionGroups) + '\n';
};


const gerarTextoFinal = (
  qualPagamento: IPaymentType,
  loginInfo: ILoginData | undefined,
  shoppingBag: IShoppingBagData | undefined) => {

  return template
    .replace("{nomeDoCliente}", loginInfo?.name || "")
    .replace("{numeroDoPedido}", shoppingBag?.id ? shoppingBag.id.toString() : "")
    .replace("{deliveryOuPickup}", shoppingBag?.withdraw ? "retirada" : "entrega")
    .replace("{valorTotal}", shoppingBag?.total ? (shoppingBag.total).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    }) : "")
    .replace("{formaPagamento}", qualPagamento?.description || "")
    .replace("{comOuSemTrocoEQuanto}", shoppingBag?.change_value ? `com troco para ${(shoppingBag?.change_value).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    })}` : "sem troco")
    .replace("{itensDoPedido}", shoppingBag?.items.map(mapItem)?.join("") ?? "");
};

/**
 *
 * @param placeInfo
 * @param qualPagamento Obs: possivelmente algum dia vai poder pagar com mais de uma forma de pagamento...
 * @param loginInfo
 * @param shoppingBag
 */
const gerarLink =
  (placeInfo: IPlaceData, qualPagamento: IPaymentType, loginInfo: ILoginData, shoppingBag: IShoppingBagData) => {

    const textoFinal = gerarTextoFinal(qualPagamento, loginInfo, shoppingBag);
    const textoEncoded = encodeURIComponent(textoFinal);

    const onlyNumbers = (placeInfo.whatsapp_number || "")
      .replaceAll(/[^0-9]/g, "");

    const placePhoneNumberWithBrazilCode = `55${onlyNumbers}`;

    return `https://wa.me/${placePhoneNumberWithBrazilCode}?text=${textoEncoded}`;
  };

export {
  subitens,
  mapItem,
  gerarTextoFinal,
  gerarLink
};

/*
https://faq.whatsapp.com/5913398998672934

Create your own link
Use https://wa.me/'number' where the 'number' is a full phone number in international format. Omit any zeroes, brackets,
or dashes when adding the phone number in international format.
Examples:
Use: https://wa.me/1XXXXXXXXXX
Don't use: https://wa.me/+001-(XXX)XXXXXXX
 */

/*
 Exemplo (template geral):
 ***********************************************************************************************************
 Olá, sou {nomeDoCliente} e acabei de fazer o pedido nº {numeroDoPedido}.
 O pedido é {deliveryOuPickup} e o valor total é {valorTotal} em {formaPagamento} {comOuSemTrocoEQuanto}.
 Os itens:
  {itensDoPedido}

  Obrigado!
  ***********************************************************************************************************

  Exemplo dos itensDoPedido:
     - {qtd}x {nomeDoProduto}
        - {nomeCategoria}
            - {qtdItemCategoria}x {nomeItem}
                    - {observacaoDoItem}
  ***********************************************************************************************************
 */